import Pagination from './pagination/en_US';
import DatePicker from './datePicker/en_US';
import TimePicker from './timePicker/en_US';
import Calendar from './calendar/en_US';

export default {
  locale: 'en',
  Pagination,
  DatePicker,
  TimePicker,
  Calendar,
  global: {
    placeholder: 'Please select',
  },
  Form: {
    switchControl: 'Switch Control',
  },
  Table: {
    filterTitle: 'Filter menu',
    filterConfirm: 'OK',
    filterReset: 'Reset',
    selected: 'Selected',
    selectAll: 'Select current page',
    selectInvert: 'Invert current page',
    sortTitle: 'Sort',
    expand: 'Expand row',
    collapse: 'Collapse row',
    term: 'Term',
    allData: '',
    selectedAll: 'Select All'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Cancel',
    clearText: 'Clear',
    justOkText: 'OK',
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Cancel',
    removeFile: 'Remove file',
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Search here',
    itemUnit: 'item',
    itemsUnit: 'items',
  },
  Download: {
    error: 'Download Failed',
    success: 'Download Succeeded',
    messageLink: 'Unrecognized file download link!',
    messageRequest: 'Unrecognized available download request address!',
  },
  Upload: {
    error: 'Upload failed',
    success: 'Upload succeeded',
    uploading: 'Uploading...',
    removeFile: 'Remove file',
    uploadError: 'Upload error',
    previewFile: 'Preview file',
    downloadFile: 'Download file',
    downloadTemplate: 'Download template',
  },
  Empty: {
    description: 'No Data',
  },
  Icon: {
    icon: 'icon',
  },
  Text: {
    edit: 'Edit',
    copy: 'Copy',
    copied: 'Copied',
    expand: 'Expand',
  },
  PageHeader: {
    back: 'Back',
    loginOut: 'Login Out',
  },
  Breadcrumb: {
    more: 'More',
  },
  ElectronicDocument: {
    upload: 'Upload Electronic Files',
  },
  SpeedDials: {
    title: 'Speed Dials',
  },
};
